import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import {
  ConfiguracionFormulario,
  PosicionLabelFormulario,
  TipoCampoFormulario,
} from 'src/app/compartido/formulario/utilidades/formulario.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';

/* Configuración de la ficha de cancelar orden */
export const CONFIGURACION_FICHA_CANCELAR_ORDEN: ConfiguracionFicha = {
  header: { titulo: 'Cancelar Orden', icono: Icono.CANCELAR },
  contenido: { padding: true },
  maxWidth: 1000,
};

/* Configuración del formulario de cancelar orden */
export const CONFIGURACION_FORMULARIO_CANCELAR_ORDEN: ConfiguracionFormulario =
  {
    campos: [
      {
        slug: 'motivo',
        nombre: 'Motivo',
        tipo: TipoCampoFormulario.OPCION_MULTIPLE,
        opciones: [
          {
            nombre: 'Tiene errores',
            valor: 'Tiene errores',
          },
          { nombre: 'Duplicada', valor: 'Duplicada' },
          { nombre: 'Otro', valor: 'Otro' },
        ],
        requerido: true,
      },
      {
        slug: 'observacion',
        nombre: 'Observación',
        tipo: TipoCampoFormulario.TEXTO,
      },
    ],
    estilo: {
      widthCampo: 1000,
      posicionLabel: PosicionLabelFormulario.TOP,
    },
  };
